import request from '../../../api/api';
import {DOCS_ACTION} from './types';

export default function (id, type) {
    return dispatch => {
        return request('/v1/documents?object_type=' + type + '&object_id=' + id).then(
            data => {
                dispatch({
                    type: DOCS_ACTION,
                    payload: data.data,
                });
            }
        ).catch(data => {
            if (!data.data) {
                return Promise.reject(data);
            }
            if (!data.data.error) {
                return Promise.reject(data);
            }
            dispatch({
                type: DOCS_ACTION,
                payload: {...data.data, details: [], invoices: []},
            });
        })
    }
}



/** WEBPACK FOOTER **
 ** ./src/modules/documents/actions/LoadDocs.js
 **/